import React from 'react';
import '../../../../scss/_byUserPanel.scss';
import { isMobileScreen } from '@apply/ui';
import { ByUserTable } from './components/ByUserTable';
import { ByUserMobilePanel } from './components/ByUserMobilePanel';
import { GenericAlertPopup, ProgressSpinner } from '@apply/components';
import { useAuthorizedUsersQuery, useRefreshUserManagement } from '../../../../../manageusers/queries/userManagementQueries';

export const ByUserPanel: React.FC = () => {
    const mobileScreen = isMobileScreen();
    const { data: authorizedUsers = [], isLoading, error } = useAuthorizedUsersQuery();
    const refreshUsers = useRefreshUserManagement();

    if (error) {
        GenericAlertPopup({
            title: 'Error',
            children: error.message || 'Failed to load user data. Please try again.',
            width: '350px',
        });
    }

    return (
        <>
            <div className={`byUserPanel ${mobileScreen ? 'mobile' : 'nonMobile'}`}>
                {isLoading && (
                    <div className='loadingOverlay'>
                        <div className='stickySpinner'>
                            <ProgressSpinner />
                        </div>
                    </div>
                )}
                <div style={{ opacity: isLoading ? 0.7 : 1, pointerEvents: isLoading ? 'none' : 'auto' }}>
                    {!isLoading && authorizedUsers.length < 1 && (
                        <div style={{ textAlign: 'center', paddingTop: '3rem' }}>
                            <h3>You don't currently have any users to manage.</h3>
                        </div>
                    )}
                    {authorizedUsers.length > 0 && !mobileScreen && (
                        <ByUserTable
                            users={authorizedUsers}
                            onRefresh={refreshUsers}
                        />
                    )}
                    {authorizedUsers.length > 0 && mobileScreen && (
                        <>
                            {authorizedUsers.map((user) => (
                                <ByUserMobilePanel
                                    key={user.id}
                                    user={user}
                                    onRefresh={refreshUsers}
                                />
                            ))}
                        </>
                    )}
                </div>
            </div>
        </>
    );
};
